
/* Disable best-selling url */
var url = window.location.href;
if (url.indexOf("best-selling") >= 0) {
  document.location.href = "https://ifaun.com";
}

/* Mega-menu implementation */
class MegaMenu {
  static currentOpenMenu = null;

  constructor(menu) {
    this.menu = menu;
    this.button = menu.querySelector("button");
    this.content = menu.querySelector(".mega-menu__content");
    this.link = this.button.querySelector("a");
    this.timeout = null;
    this.init();
  }

  init() {
    this.button.addEventListener("click", this.handleInteraction.bind(this));
    this.button.addEventListener(
      "touchstart",
      this.handleInteraction.bind(this)
    );
    this.menu.addEventListener("mouseover", () => {
      clearTimeout(this.timeout);
      this.menu.classList.add("is-open");
      MegaMenu.currentOpenMenu = this.menu;
    });
    this.menu.addEventListener("mouseleave", () => {
      this.timeout = setTimeout(() => {
        this.menu.classList.remove("is-open");
        if (MegaMenu.currentOpenMenu === this.menu) {
          MegaMenu.currentOpenMenu = null;
        }
      }, 100);
    });
    this.content.addEventListener("mouseover", () =>
      clearTimeout(this.timeout)
    );
    this.content.addEventListener("touchstart", (e) => e.stopPropagation());
  }

  handleInteraction(e) {
    if (this.link?.href) {
      window.location.href = this.link.href;
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    if (MegaMenu.currentOpenMenu && MegaMenu.currentOpenMenu !== this.menu) {
      MegaMenu.currentOpenMenu.classList.remove("is-open");
    }

    this.menu.classList.toggle("is-open");
    MegaMenu.currentOpenMenu = this.menu.classList.contains("is-open")
      ? this.menu
      : null;
  }
}

document.querySelectorAll(".mega-menu").forEach((menu) => new MegaMenu(menu));
